<div class="solutions-page">
  <div class="row">
    <div class="col-12 solutions-page-banner">
      <video autoplay muted loop playsinline class="haveVideo--video">
        <source
          src="./../../assets/images/solutions-video.mp4"
          type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div class="container-xl">
        <div class="inner-banner">
          <span class="f-m" data-aos="fade-right" data-aos-duration="1200">
            Inbound Contact Center Solution
          </span>
          <h2 class="f-p" data-aos="fade-down" data-aos-duration="800">
            {{ herosConfig.title }}
          </h2>
          <p class="f-m" data-aos="fade-down" data-aos-duration="1000">
            {{ herosConfig.description }}
          </p>
          <button
            type="button"
            class="primaryBtn text-uppercase"
            data-aos="fade-down"
            data-aos-duration="600"
            (click)="bookConsult()">
            GET A PERSONALIZED DEMO
          </button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="container-xl">
        <div class="title">
          <h2 class="f-p" data-aos="fade-down" data-aos-duration="500">
            Beyond Contact Management - We Deliver Transformation
          </h2>
        </div>

        <div class="cm-row">
          <div class="cm-col" data-aos="fade-right" data-aos-duration="500">
            <div class="cont">
              <p class="f-p">
                Blended AI & Human Support - AI speeds up resolutions, and
                experienced agents handle complex interactions.
              </p>
            </div>
          </div>
          <div class="cm-col" data-aos="flip-up" data-aos-duration="500">
            <div class="cont">
              <p class="f-p">
                Predictive Call Routing - Every customer connects with the right
                agent, instantly.
              </p>
            </div>
          </div>
          <div class="cm-col" data-aos="fade-left" data-aos-duration="500">
            <div class="cont">
              <p class="f-p">
                Scaleble & Adaptive - Grow without worrying about staffing or
                technology constraints.
              </p>
            </div>
          </div>
          <div class="cm-col" data-aos="fade-right" data-aos-duration="500">
            <div class="cont">
              <p class="f-p">
                Always-On Monitoring & Optimization - Data-driven insights
                improve efficiency and outcomes in real time.
              </p>
            </div>
          </div>
          <div class="cm-col" data-aos="flip-up" data-aos-duration="500">
            <div class="cont">
              <p class="f-p">
                Omnichanel Experience - Seamlessly integrate voice, email, chat,
                and social for a unified customer journey.
              </p>
            </div>
          </div>
          <div class="cm-col" data-aos="fade-left" data-aos-duration="500">
            <div class="cont">
              <p class="f-p">
                Real-Time Analytics - Gain actionable insights to optimize agent
                performance and enhance customer satisfaction.
              </p>
            </div>
          </div>
        </div>
        <div class="client-logos">
          <div class="label-txt">
            <h4 class="f-p">Trusted by the best:</h4>
          </div>

          <div class="logo-slider">
            <div class="item" *ngFor="let logo of logos">
              <img alt="" [src]="logo" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 lightBlue stay-connected">
      <div class="container-xl">
        <div class="title">
          <p class="f-m" data-aos="fade-down" data-aos-duration="500">
            Why Invictus + iKunnect?
          </p>
          <h2 class="f-p" data-aos="fade-down" data-aos-duration="600">
            Most businesses struggle with high agent turnover, disjointed
            software, and reactive customer service.
          </h2>
        </div>
        <div class="custom-tabs vertical-tabs">
          <div class="row">
            <div class="col-md-3 col-lg-4">
              <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" data-bs-toggle="tab" href="#tab1">
                    4% Attrition vs 30%+ Industry Average
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-bs-toggle="tab" href="#tab2">
                    AI-Powered Contact Management
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-bs-toggle="tab" href="#tab3">
                    Omnichannel, Seamless Experience
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-bs-toggle="tab" href="#tab4">
                    24/7 Nearshore Support in your Time Zone
                  </a>
                </li>
              </ul>
              <!--<button
                (click)="isChatEnabled = true"
                type="button"
                class="primaryBtn smt3 lets-chat">
                LET'S CHAT
              </button>-->
            </div>
            <div class="col-md-9 col-lg-8">
              <div class="tab-content">
                <div id="tab1" class="tab-pane active">
                  <div class="stay-connected-cont">
                    <h4 class="f-p">4% Attrition</h4>
                    <p>
                      A stable, trained workforce ensures long-term customer
                      satistaction.
                    </p>
                    <ul>
                      <li>
                        <strong>Highly experienced agents:</strong>
                        Out team retention means customers interact with
                        knowledgeable professionals.
                      </li>
                      <li>
                        <strong>Reduced training costs:</strong>
                        Lower attrition reduces the need for constant new-hire
                        training.
                      </li>
                      <li>
                        <strong>Consistent service quality:</strong>
                        Customers receive better, more personalized support from
                        tenured agents.
                      </li>
                      <li>
                        <strong>Stronger customer relationships:</strong>
                        Familiarity and experience improve brand loyalty.
                      </li>
                    </ul>
                  </div>
                </div>
                <div id="tab2" class="tab-pane fade">
                  <div class="stay-connected-cont">
                    <h4 class="f-p">AI-Powered Call Management</h4>
                    <p>
                      Smart routing, automated follow-ups, and real time
                      insights to boost efficiency.
                    </p>
                    <ul>
                      <li>
                        <strong>Predictive Call Routing:</strong>
                        AI instantly connects customers with the right agent for
                        faster resolutions.
                      </li>
                      <li>
                        <strong>Automated Follow-Ups:</strong>
                        Never miss a customer callback or case update with
                        reminders.
                      </li>
                      <li>
                        <strong>Advanced UVR & Self-Service:</strong>
                        Reduce agent load by empowering customers to self-serve
                        for simple issues.
                      </li>
                      <li>
                        <strong>Real-Time Sentiment Analysis:</strong>
                        AI detects customer frustration or satisfaction and
                        adjusts routing dynamically.
                      </li>
                    </ul>
                  </div>
                </div>
                <div id="tab3" class="tab-pane fade">
                  <div class="stay-connected-cont">
                    <h4 class="f-p">Omnichannel, Seamless Experience</h4>
                    <p>Calls, emails, chat, and social - all in one platform</p>
                    <ul>
                      <li>
                        <strong>Unified Agent Dashboard:</strong>
                        Agents handle multiple channels from a single interface,
                        ensuring efficiency.
                      </li>
                      <li class="inner-list">
                        <strong>AI-Powered Chatbots:</strong>
                        Automate initial inquiries and escalate complex issues
                        to human agents.
                      </li>
                      <li>
                        <strong>Integrated CRM & Ticketing:</strong>
                        Maintain customer history across interactions for
                        seamless resolutions.
                      </li>
                      <li>
                        <strong>24/7 Multilingual Support:</strong>
                        Native English and bilingual agents make our contact
                        centers a powerhouse providing round-the-clock coverage
                        to global customers.
                      </li>
                    </ul>
                  </div>
                </div>
                <div id="tab4" class="tab-pane fade">
                  <div class="stay-connected-cont">
                    <h4 class="f-p">
                      24/7 Nearshore Support in Your Time Zone
                    </h4>
                    <p>
                      English-first, Multilingual agents based in Belize for
                      seamless U.S. alignment with global reach.
                    </p>
                    <ul>
                      <li>
                        <strong>Close Proximity to the U.S.:</strong>
                        Just a short flight away, ensuring easy collaboration
                        and time zone alignment.
                      </li>
                      <li>
                        <strong>U.S. Cultural Affinity:</strong>
                        Agents are fluent in English with a deep understanding
                        of American business communication and customer
                        expectations.
                      </li>
                      <li>
                        <strong>Real-Time Support Across Regions:</strong>
                        Operating in U.S. time zones while also covering Latin
                        America, Europe, and global markets with multilingual
                        teams.
                      </li>
                      <li>
                        <strong>Multilingual Expertise:</strong>
                        Spanish, French, Portuguse, and other native-speaking
                        agents provide accurate, natural communication.
                      </li>
                      <li>
                        <strong>Adaptive Language Solution:</strong>
                        AI-assisted translation tools and native-speaking agents
                        provide accurate, natural communication.
                      </li>
                      <li>
                        <strong
                          >Cost-Effective Without Sacraficing Quality:</strong
                        >
                        Nearshore pricing with onshore-level service, ensuring
                        high- quality interactions across all supported
                        languages.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-transform-customer-service class="spa0 col-12" />
    <app-book-consultation [title]="title" class="spa0 col-12" />
    <app-lets-chat *ngIf="isChatEnabled"></app-lets-chat>
  </div>
</div>
